<template>
    <b-dropdown
        :disabled="disabled"
        :no-caret="noCaret"
        :size="size"
        :variant="(outline ? 'outline-' : '') + color"
        @click="$emit('click', $event)"
        v-bind="dropPosition"
    >
        <slot
            name="button-content"
            slot="button-content"
        />

        <slot />
    </b-dropdown>
</template>

<script>
import { BDropdown } from 'bootstrap-vue'

export default {
    components: { BDropdown },
    computed: {
        size() {
            return this.small ? 'sm' : (this.large ? 'lg' : (''))
        },
        dropPosition() {
            if(this.position == 'left')
                return { dropleft: true }
            else if (this.potision == 'right')
                return { dropright: true }
            else if(this.potision == 'up')
                return { dropup: true }

            return {}
        }
    },
    props: {
        color: { type: String, default: 'secondary' },
        disabled: { type: Boolean },
        large: { type: Boolean },
        noCaret: { type: Boolean },
        outline: { type: Boolean },
        position: { type: String },
        small: { type: Boolean },
    }
}
</script>